<template>

</template>

<script>
    import VueFormGenerator from "vue-form-generator/dist/vfg.js";

    Vue.use(VueFormGenerator);

    export default {

        props: ["model", "schema"],

        methods: {

            init: function () {

                this.model.terms = [];

                this.schema.groups.push( {
                        fields: [
                            {
                                type: "checklist",
                                label: "Splošni pogoji poslovanja",
                                model: "terms",
                                listBox: true,
                                values: [
                                    {
                                        id: "consent_1",
                                        name: "Želim prejemati nedeljska pisma in ekskluzivna povabila na dogodke, delavnice in progame."
                                    },
                                    {
                                        id: "consent_2",
                                        name: "Želim prejeti email sporočila in videti oglase, ki bodo povečala moj sijaj, zdravje in lepoto."
                                    },
                                ],
                                checklistOptions: {
                                    value: "id"
                                },
                                styleClasses: 'col-sm-12',
                                validator: function (value, field) {
                                    // let termsNumber = field.values.length;
                                    // 1 + 2 + 3 are required
                                    // console.log(value);
                                    // console.log(typeof value.terms);
                                    // console.log(typeof value["terms"]);
                                    // console.log("validation");
                                    // console.log(typeof value["terms"] === "undefined");
                                    // console.log(typeof value["terms2"] === "undefined");
                                    // console.log(typeof value["consent_1"] === "undefined");
                                    // console.log(value);
                                    // console.log("FIELD");
                                    // console.log(value);
                                    // if(value.indexOf("terms") === -1 || value.indexOf("terms2") === -1 || value.indexOf("consent_1") === -1) {
                                    //     return ['Za oddajo naročila se strinjate s <a href="https://savinaatai.com/splosni-pogoji" target="_blank" style="color:inherit;">splošnimi pogoji poslovanja</a>'];
                                    // }

                                },
                                hint: "Zavod se zavezuje vaše osebne podatke hraniti, obdelovati in upravljati z njimi izključno za namen, za katerega so bili pridobljeni ter za namene obveščanja in marketinške aktivnosti, skladno z internimi akti Zavoda, Politiko zasebnosti, Pogoji sodelovanja in uporabe in veljavno zakonodajo. Z oddajo naročila se zavezujete in jamčite, da so vsi spodaj izpisani podatki pravilni in resnični. Z oddajo naročila se strinjate s splošnimi pogoji poslovanja. Z oddajo naročila se strinjate z obdelavo podatkov za namene izpolnitve kupoprodajne pogodbe."
                            }
                        ]
                    },
                );

            }
        }

    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/modules/Terms.vue